module.exports = __webpack_public_path__ + "circle_bookshelf_sm.e6e3994d.svg";